// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"WW-z","inlineTitle":"XW-z","sponsoredAdsWrapper":"YW-z","marketplaceRecosWrapper":"ZW-z"};